import React, { useState } from "react";
import "../../_css/OurPlans.css";
import RichTextEditor from "../common/RichTextEditor";
import { contactUs } from "../../requests";
import { notifySuccess, notifyError } from "../../utils/helper";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { useDispatch } from "react-redux";

const ContactUs = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const [subject, setSubject] = useState("Regarding school customized plan");
  const [description, setDescription] = useState("We are interested in learning more about your customized plan. Please provide information regarding pricing, features, and implementation timeline.");

  if (!isOpen) return null;

 const validateDescription = () => {
  if(!description.trim()) {
    notifyError("Please enter your message");
    return false;
  }
  //its in html format
  const div = document.createElement("div");
  div.innerHTML = description;
  if(div.textContent.trim() == "") {
    notifyError("Please enter your message");
    return false;
  }
  return true;
 }

  const handleSubmit = async (e) => {
    e.preventDefault();

  if(!validateDescription()) {
    return;
  }

    dispatch(startLoader());

    try {
      const response = await contactUs({ subject, description });
      if(response.status == 200) {
        notifySuccess(response.data.message);
        setSubject("Regarding school customized plan");
        setDescription("We are interested in learning more about your customized plan. Please provide information regarding pricing, features, and implementation timeline.");
        onClose();
      }
    } catch (error) {
      console.error("Error contacting us:", error);
      notifyError(error?.response?.data?.error || "Something went wrong");
    } finally {
      dispatch(stopLoader());
    }

  
  };

  const handleClose = () => {
    setSubject("Regarding school customized plan");
    setDescription("We are interested in learning more about your customized plan. Please provide information regarding pricing, features, and implementation timeline.");
    onClose();
  }

  return (
    <div className="contact-modal-overlay" onClick={handleClose}>
      <div
        className="contact-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="contact-modal-head">
          <div className="contact-modal-head-text">Contact Us</div>
          <img
            style={{ cursor: "pointer" }}
            onClick={handleClose}
            src="/close.svg"
            alt="Close"
          />
        </div>
        <div className="contact-modal-body">
          <form
            onSubmit={handleSubmit}
            className="contact-form-section"
            style={{ display: "flex", flexDirection: "column", gap: "12px" }}
          >
            <div className="contact-form-field">
              <label
                htmlFor="contact-subject"
                className="contact-label"
                style={{ display: "block", marginBottom: "4px" }}
              >
                Subject
              </label>
              <input
                id="contact-subject"
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="contact-input"
                style={{
                  width: "100%",
                  padding: "8px 10px",
                  borderRadius: "6px",
                  border: "1px solid #dee2e6",
                  fontSize: "14px",
                  backgroundColor: "#f3f4f6",
                  cursor: "not-allowed",
                }}
                placeholder="Subject of your message"
                readOnly={true}
            
              />
            </div>

            <div className="contact-form-field">
              <RichTextEditor
                label="Message"
                labelClassName="contact-label"
                value={description}
                onChange={setDescription}
                height="300px"
              />
            </div>

            <button
              type="submit"
              className="contact-submit-button"
              style={{
                alignSelf: "flex-end",
                marginTop: "8px",
                padding: "8px 16px",
                borderRadius: "20px",
                border: "none",
                backgroundColor: "#01a7de",
                color: "#fff",
                fontSize: "14px",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Send Email
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;

